package com.anjuros.website.templates.template9.util

import com.anjuros.website.components.language.Language
import com.anjuros.website.components.language.ResKeyType


enum class ResKey : ResKeyType {

    TEMPLATE9_SECTION1,
    TEMPLATE9_SECTION2,
    TEMPLATE9_SECTION3,
    TEMPLATE9_SECTION4,
    TEMPLATE9_SECTION5,

    TEMPLATE9_BUTTON_BOOK,
    TEMPLATE9_BUTTON_LEARN,
    TEMPLATE9_LOGO_SUBTITLE,

    TEMPLATE9_HERO_TITLE,
    TEMPLATE9_HERO_SUBTITLE,
    TEMPLATE9_HERO_TITLE2,
    TEMPLATE9_HERO_DESCRIPTION,

    TEMPLATE9_ABOUT_EYEBROW,
    TEMPLATE9_ABOUT_TITLE,
    TEMPLATE9_ABOUT_PARAGRAPH,
    TEMPLATE9_INFO_TITLE1,
    TEMPLATE9_INFO_DESC1,
    TEMPLATE9_INFO_TITLE2,
    TEMPLATE9_INFO_DESC2,
    TEMPLATE9_INFO_TITLE3,
    TEMPLATE9_INFO_DESC3,

    TEMPLATE9_SERVICES_EYEBROW,
    TEMPLATE9_SERVICES_TITLE,
    TEMPLATE9_SERVICE1_TITLE,
    TEMPLATE9_SERVICE1_DESC,
    TEMPLATE9_SERVICE2_TITLE,
    TEMPLATE9_SERVICE2_DESC,
    TEMPLATE9_SERVICE3_TITLE,
    TEMPLATE9_SERVICE3_DESC,
    TEMPLATE9_SERVICE4_TITLE,
    TEMPLATE9_SERVICE4_DESC,
    TEMPLATE9_PRICE_FROM,
    TEMPLATE9_PER_WALK,
    TEMPLATE9_PER_VISIT,
    TEMPLATE9_PER_NIGHT,

    TEMPLATE9_WHY_EYEBROW,
    TEMPLATE9_WHY_CHOOSE_TITLE,
    TEMPLATE9_WHY_CHOOSE_SUBTITLE,
    TEMPLATE9_WHY1_TITLE,
    TEMPLATE9_WHY1_DESC,
    TEMPLATE9_WHY2_TITLE,
    TEMPLATE9_WHY2_DESC,
    TEMPLATE9_WHY3_TITLE,
    TEMPLATE9_WHY3_DESC,
    TEMPLATE9_WHY4_TITLE,
    TEMPLATE9_WHY4_DESC,

    TEMPLATE9_REVIEWS_EYEBROW,
    TEMPLATE9_REVIEWS_TITLE,
    TEMPLATE9_REVIEW1,
    TEMPLATE9_REVIEW1_NAME,
    TEMPLATE9_REVIEW2,
    TEMPLATE9_REVIEW2_NAME,
    TEMPLATE9_REVIEW3,
    TEMPLATE9_REVIEW3_NAME,

    TEMPLATE9_FAQ_EYEBROW,
    TEMPLATE9_FAQ_TITLE,
    TEMPLATE9_FAQ1_Q,
    TEMPLATE9_FAQ1_A,
    TEMPLATE9_FAQ2_Q,
    TEMPLATE9_FAQ2_A,
    TEMPLATE9_FAQ3_Q,
    TEMPLATE9_FAQ3_A,
    TEMPLATE9_FAQ4_Q,
    TEMPLATE9_FAQ4_A,
    TEMPLATE9_FAQ5_Q,
    TEMPLATE9_FAQ5_A,
    TEMPLATE9_FAQ6_Q,
    TEMPLATE9_FAQ6_A,

    TEMPLATE9_CONTACT_TITLE,
    TEMPLATE9_CONTACT_SUBTITLE,
    TEMPLATE9_CONTACT_CARD_TITLE;

    override val keyName: String
        get() = name
}


val TextResources = mapOf(
    Language.EN to mapOf(

        ResKey.TEMPLATE9_SECTION1 to "Home",
        ResKey.TEMPLATE9_SECTION2 to "Services",
        ResKey.TEMPLATE9_SECTION3 to "About Me",
        ResKey.TEMPLATE9_SECTION4 to "FAQ",
        ResKey.TEMPLATE9_SECTION5 to "Contact",

        ResKey.TEMPLATE9_BUTTON_BOOK to "Book a Walk",
        ResKey.TEMPLATE9_BUTTON_LEARN to "Learn More",
        ResKey.TEMPLATE9_LOGO_SUBTITLE to "DOG WALKING",

        ResKey.TEMPLATE9_HERO_TITLE to "Adventure Awaits!",
        ResKey.TEMPLATE9_HERO_SUBTITLE to "Professional dog walking with",
        ResKey.TEMPLATE9_HERO_TITLE2 to "love & care",
        ResKey.TEMPLATE9_HERO_DESCRIPTION to "Reliable, friendly and fully insured dog walking services in your local area.",

        ResKey.TEMPLATE9_ABOUT_EYEBROW to "About me",
        ResKey.TEMPLATE9_ABOUT_TITLE to "A True Dog Lover You Can Trust",
        ResKey.TEMPLATE9_ABOUT_PARAGRAPH to "I'm Anna, a passionate dog lover with years of experience caring for dogs of all breeds, sizes and personalities.",
        ResKey.TEMPLATE9_INFO_TITLE1 to "Fully Insured & DBS Checked",
        ResKey.TEMPLATE9_INFO_DESC1 to "Your dog's safety is my top priority.",
        ResKey.TEMPLATE9_INFO_TITLE2 to "Personalised Care",
        ResKey.TEMPLATE9_INFO_DESC2 to "Every dog is unique and treated like family.",
        ResKey.TEMPLATE9_INFO_TITLE3 to "Reliable & Flexible",
        ResKey.TEMPLATE9_INFO_DESC3 to "Walks tailored around your dog's needs.",

        ResKey.TEMPLATE9_SERVICES_EYEBROW to "What I offer",
        ResKey.TEMPLATE9_SERVICES_TITLE to "My Services",
        ResKey.TEMPLATE9_SERVICE1_TITLE to "Solo Dog Walks",
        ResKey.TEMPLATE9_SERVICE1_DESC to "One-to-one walks tailored to your dog's needs.",
        ResKey.TEMPLATE9_SERVICE2_TITLE to "Group Walks",
        ResKey.TEMPLATE9_SERVICE2_DESC to "Fun, social walks with compatible dog friends.",
        ResKey.TEMPLATE9_SERVICE3_TITLE to "Home Visits",
        ResKey.TEMPLATE9_SERVICE3_DESC to "Drop-in visits for feeding, playtime and cuddles.",
        ResKey.TEMPLATE9_SERVICE4_TITLE to "Overnight Care",
        ResKey.TEMPLATE9_SERVICE4_DESC to "Comforting overnight stays in your home.",
        ResKey.TEMPLATE9_PRICE_FROM to "From",
        ResKey.TEMPLATE9_PER_WALK to "/ walk",
        ResKey.TEMPLATE9_PER_VISIT to "/ visit",
        ResKey.TEMPLATE9_PER_NIGHT to "/ night",

        ResKey.TEMPLATE9_WHY_EYEBROW to "Why choose",
        ResKey.TEMPLATE9_WHY_CHOOSE_TITLE to "Happy Dogs,",
        ResKey.TEMPLATE9_WHY_CHOOSE_SUBTITLE to "Happy Owners",
        ResKey.TEMPLATE9_WHY1_TITLE to "Passion",
        ResKey.TEMPLATE9_WHY1_DESC to "I genuinely love dogs and caring for them.",
        ResKey.TEMPLATE9_WHY2_TITLE to "Safety First",
        ResKey.TEMPLATE9_WHY2_DESC to "Fully insured with your dog's safety always first.",
        ResKey.TEMPLATE9_WHY3_TITLE to "Flexible Times",
        ResKey.TEMPLATE9_WHY3_DESC to "Early mornings, lunchtime or evening, I'm here to help.",
        ResKey.TEMPLATE9_WHY4_TITLE to "Trusted Service",
        ResKey.TEMPLATE9_WHY4_DESC to "Lots of happy dogs and even happier owners!",

        ResKey.TEMPLATE9_REVIEWS_EYEBROW to "Happy clients",
        ResKey.TEMPLATE9_REVIEWS_TITLE to "What They Say",
        ResKey.TEMPLATE9_REVIEW1 to "Anna is amazing! My dog gets so excited when she arrives. I know he's in the best hands.",
        ResKey.TEMPLATE9_REVIEW1_NAME to "Sarah & Buddy",
        ResKey.TEMPLATE9_REVIEW2 to "Reliable, trustworthy and so caring. I wouldn't trust anyone else with my pup!",
        ResKey.TEMPLATE9_REVIEW2_NAME to "James & Max",
        ResKey.TEMPLATE9_REVIEW3 to "Great communication and regular updates. It gives me such peace of mind.",
        ResKey.TEMPLATE9_REVIEW3_NAME to "Emily & Bella",

        ResKey.TEMPLATE9_FAQ_EYEBROW to "FAQ",
        ResKey.TEMPLATE9_FAQ_TITLE to "Frequently Asked Questions",
        ResKey.TEMPLATE9_FAQ1_Q to "Are you insured?",
        ResKey.TEMPLATE9_FAQ1_A to "Yes, I'm fully insured, DBS checked and trained in canine first aid, so your dog is always in safe hands.",
        ResKey.TEMPLATE9_FAQ2_Q to "What areas do you cover?",
        ResKey.TEMPLATE9_FAQ2_A to "I cover Stafford and the surrounding villages. If you're not sure whether I cover your area, just get in touch.",
        ResKey.TEMPLATE9_FAQ3_Q to "How long are the walks?",
        ResKey.TEMPLATE9_FAQ3_A to "Walks are usually 30 or 60 minutes, but I'm happy to tailor the length to your dog's age and energy.",
        ResKey.TEMPLATE9_FAQ4_Q to "Do you walk puppies?",
        ResKey.TEMPLATE9_FAQ4_A to "Absolutely! I offer short puppy visits with play, toilet breaks and gentle lead training.",
        ResKey.TEMPLATE9_FAQ5_Q to "What happens in bad weather?",
        ResKey.TEMPLATE9_FAQ5_A to "Walks go ahead in most weather. In extreme heat or storms I'll swap to a shorter walk or an indoor play visit.",
        ResKey.TEMPLATE9_FAQ6_Q to "How do I book a walk?",
        ResKey.TEMPLATE9_FAQ6_A to "Call, email or send a message through the form. We'll start with a free meet-and-greet to get to know your dog.",

        ResKey.TEMPLATE9_CONTACT_TITLE to "Ready to Book?",
        ResKey.TEMPLATE9_CONTACT_SUBTITLE to "Let's make tails wag! Get in touch today to book a walk.",
        ResKey.TEMPLATE9_CONTACT_CARD_TITLE to "Send me a message",
    ),
)
